module.exports = __webpack_public_path__ + "static/media/news-bg.343f4688.jpg";